import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import Dashboard from "../../../layout/Dashboard";
import { systemService } from '../../../services/SystemService';
import { ListHead, ListRow } from "../../../styles/CrypoAssetStyle";
import { Content, Heading } from "../../../styles/OverviewStyle";
import { RFDesc, RFMain, RFTitle, RFWrap } from "../../../styles/RatesFeesStyle";
import { RatesNavigator, TabNavigator } from "../components/Navigator";

export default function DollarConversionRates() {
   const [rate, setRate] = useState('')
   const [graphRate, setGraphRate] = useState('')
   const [loading, setLoading] = useState(true)
   const [editing, setEditing] = useState(false)
   const [value, setValue] = useState('')

   useEffect(() => {
      loadRates()
   }, [])

   const loadRates = async () => {
      try {
         const [dollarResponse, graphResponse] = await Promise.all([
            systemService.getDollarConversionRate(),
            systemService.getGraphConversionRate()
         ])
         if (dollarResponse.status === 'success' && dollarResponse.data) {
            setRate(dollarResponse.data.rate)
         }
         if (graphResponse.status === 'success' && graphResponse.data) {
            setGraphRate(graphResponse.data.rate.toString())
         }
      } catch (error) {
         console.error('Failed to load rates:', error)
      } finally {
         setLoading(false)
      }
   }

   const onEdit = () => { setValue(rate); setEditing(true) }
   const onCancel = () => { setEditing(false) }
   const onSave = async () => {
      try {
         const rateValue = parseFloat(value.replace(/[^0-9.]/g, ''))
         if (isNaN(rateValue)) return
         await systemService.updateDollarConversionRate({ rate: rateValue })
         await loadRates()
         setEditing(false)
      } catch (error) {
         console.error('Failed to update rate:', error)
      }
   }

   return (
      <Dashboard title="Rates & Fees / Rates / Dollar conversion" icon="solar:tag-price-linear" active="rates_fees">
         <Content>
            <Heading>Rates & Fees</Heading>

            <TabNavigator active="rates" />

            <RFWrap>
               <RatesNavigator active="dollar_conversion" />

               <RFMain>
                  <div>
                     <RFTitle>Dollar conversion</RFTitle>
                     <RFDesc>
                        Set the conversion rate for moving funds from the dollar wallet to naira. This rate is managed manually, and any updates you make here will apply instantly to user transactions
                     </RFDesc>

                     <ListHead style={{ gridTemplateColumns: '1fr 160px 160px 300px' }}>
                        <div>Name</div>
                        <div className="text-right pr-2">Graph Rate</div>
                        <div className="text-right pr-2">Rate</div>
                        <div></div>
                     </ListHead>

                     {loading ? (
                        <ListRow style={{ gridTemplateColumns: '1fr 160px 160px 300px' }}>
                           <div className="flex items-center gap-3">
                              <div className="w-5 h-5 rounded-full bg-gray-200 animate-pulse" />
                              <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                           </div>
                           <div className="h-4 w-20 bg-gray-200 rounded animate-pulse ml-auto" />
                           <div className="h-4 w-20 bg-gray-200 rounded animate-pulse ml-auto" />
                           <div className="h-4 w-8 bg-gray-200 rounded animate-pulse ml-auto" />
                        </ListRow>
                     ) : (
                        <ListRow style={{ gridTemplateColumns: '1fr 160px 160px 300px' }}>
                           <div className="flex items-center gap-3">
                              <span className="w-5 h-5 inline-flex items-center justify-center rounded-full bg-[#F1F1F3]">
                                 <Icon icon="circle-flags:us" width={14} className="text-[#101018]" />
                              </span>
                              <span className="text-sm text-[#101018]">
                                 USD
                                 &nbsp;
                                 <Icon icon="fa7-solid:exchange-alt" className="inline-flex" fontSize={7} />
                                 &nbsp;
                                 NGN
                              </span>
                           </div>
                           <div className="w-[20px] ml-auto flex justify-start">
                              <span className="text-medium text-xs text-[#858589]">₦{graphRate}</span>
                           </div>
                           <div className="w-[20px] ml-auto flex justify-start">
                              {editing ? (
                                 <input
                                    value={value}
                                    onChange={e => setValue(e.target.value)}
                                    className="w-[120px] h-8 px-3 rounded-md border border-[#E7E7E9] bg-white text-sm text-[#101018] outline-none focus:border-[#C02236]"
                                 />
                              ) : (
                                 <span className="text-medium text-xs text-[#858589]">₦{rate}</span>
                              )}
                           </div>
                           <div className="w-[250px] flex items-center justify-end gap-4">
                              {editing ? (
                                 <>
                                    <button aria-label="Cancel" onClick={onCancel}>
                                       <Icon icon="mdi:close" width={16} className="text-[#DD524D]" />
                                    </button>
                                    <button aria-label="Save" onClick={onSave}>
                                       <Icon icon="mdi:check" width={16} className="text-[#6D6D72]" />
                                    </button>
                                 </>
                              ) : (
                                 <button className="text-[#B3B3B6] text-xs hover:underline cursor-pointer" onClick={onEdit}>Edit</button>
                              )}
                           </div>
                        </ListRow>
                     )}
                  </div>
               </RFMain>
            </RFWrap>
         </Content>
      </Dashboard>
   )
}
